var map = {
	"./alerts_arrival.svg": 51153,
	"./alerts_battery_max.svg": 242,
	"./alerts_battery_min.svg": 19124,
	"./alerts_departure.svg": 12810,
	"./alerts_humidity_max.svg": 31862,
	"./alerts_humidity_min.svg": 80336,
	"./alerts_temperature_max.svg": 58367,
	"./alerts_temperature_min.svg": 33593,
	"./eta.svg": 94174,
	"./manually-start-shipment.svg": 78237,
	"./playback__video-group.svg": 60778,
	"./shipment__box.svg": 5665,
	"./shipment__container.svg": 28655,
	"./shipment__documents.svg": 90248,
	"./shipment__food.svg": 95394,
	"./shipment__group.svg": 17123,
	"./shipment__mail.svg": 15935,
	"./shipment__pallet.svg": 61840,
	"./shipment__pallete.svg": 14877,
	"./shipment__point.svg": 24872,
	"./shipment__temperature.svg": 51116,
	"./shipment_end.svg": 23790,
	"./shipment_reports.svg": 24560,
	"./shipment_start.svg": 49509,
	"./warning.svg": 81526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29288;